import { ACTIVE, CHANGE_USER_STATUS_DIALOG } from "../../../ducks/userManagement";
import { FormattedMessage, injectIntl } from "react-intl";
import React from "react";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const ChangeUserStatusDialog = (props) => {
  const { username, active, propertyChange, changeUserStatusDialog, editUser } = props;

  const onConfirmDialog = () => {
    propertyChange(ACTIVE, !active);
    editUser();
    propertyChange(CHANGE_USER_STATUS_DIALOG, false);
  };

  return (
    <Modal show={changeUserStatusDialog}>
      <Modal.Header>
        <Modal.Title>
          <FontAwesomeIcon icon={faExclamationTriangle} /> <FormattedMessage id="user.management.table.status" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id={`user.management.user.${active ? "de" : ""}activate`} values={{ username }} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => propertyChange(CHANGE_USER_STATUS_DIALOG, false)}>
          <FormattedMessage id="user.management.create.new.user.cancel" />
        </Button>
        <Button onClick={() => onConfirmDialog()}>
          <FormattedMessage id={`user.management.action.${active ? "de" : ""}activate`} />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ChangeUserStatusDialog.propTypes = {
  propertyChange: PropTypes.func,
  changeStatusDialog: PropTypes.func,
  editUser: PropTypes.func,
  username: PropTypes.string,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  password: PropTypes.string,
  currentUserId: PropTypes.number,
  active: PropTypes.bool,
  user_roles: PropTypes.array,
  changeUserStatusDialog: PropTypes.bool
};
export default injectIntl(ChangeUserStatusDialog);
